// extracted by mini-css-extract-plugin
export default {"detailsForm":"OrganizationsGeneral_detailsForm__d9147","priceIcon":"OrganizationsGeneral_priceIcon__WAVRl"};